<div class="flex min-h-dvh">
  <aside>
    <app-navbar />
  </aside>
  <main class="flex-1 min-w-0 py-6 px-8 bg-gray-50 ml-72">
    <router-outlet />
    <p-toast />
  </main>
</div>
